import React from 'react';
import { Switch, Route } from 'react-router-dom';

import List from './List';
import Edit from './Edit';

export const RoleMappingTest = () => (
	<Switch>
		<Route path="/admin/rolemappings" exact component={List} />
		<Route path="/admin/rolemappings/create" component={Edit} />
		<Route path="/admin/rolemappings/:id" component={Edit} />
	</Switch>
);
